import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export const SectionTitle = styled.h3`
  margin: 0 0 16px;
  font-size: ${fontSize.font18};
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
`;

export const NoClaimsText = styled.p`
  margin: 0;
  font-size: ${fontSize.font14};
  color: ${theme.greyText};
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ClaimedCardWrapper = styled.div`
  background: ${theme.whiteText};
  border-radius: 12px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  position: relative;
`;

export const ClaimedCardContent = styled.div`
  padding: 16px;
`;

export const ClaimedCardTitle = styled.span<{ $color?: string }>`
  display: block;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.black};
  margin-bottom: 5px;
  color: ${({ $color }) => $color || theme.blackText};
`;

export const ClaimTypeRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ClaimTypeTitle = styled.span<{ $color?: string }>`
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.regular};
  color: ${({ $color }) => $color || theme.greyText3};
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.bold};
  flex-shrink: 0;
  color: ${theme.blueText};

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const GradientBarContainer = styled.div`
  height: 4px;
  width: 100%;
  position: relative;
`;

export const GradientBarTrack = styled.div`
  position: absolute;
  inset: 0;
  background: ${theme.greyText10};
`;

export const GradientBar = styled.div<{
  $colors: string[];
}>`
  position: absolute;
  inset: 0;
  background: ${({ $colors }) =>
    `linear-gradient(to right, ${$colors.join(", ")})`};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;
